<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Staff
    </button>

    <a-drawer
      title="Add a Staff"
      :width="this.settings['isMobileView'] ? 480 : this.settings['isTabletView'] ? 720 : 1080"
      @close="handleCancel"
      :visible="visible"
      :wrapStyle="{height: 'calc(100% - 10px)', overflow: 'auto', paddingBottom: '10px'}"
      placement="right"
    >
      <a-form class="mb-4" :form="form">
        <p>Basic Details</p>
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item label="Suffix">
            <a-select
                v-decorator="[
                  'suffix',
                  {rules: [{ required: true, message: 'Suffix is required!!' }], initialValue: 'Mr'}
                ]"
              >
                <a-select-option v-for="nameSuffix in nameSuffixes" :value="nameSuffix.value" :key="nameSuffix.value">
                 {{nameSuffix.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="First name">
            <a-input
              placeholder="First name"
              v-decorator="['first_name', {rules: [{ required: true, message: 'Please input first name!' }]}]"
            />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="Last name">
            <a-input
              placeholder="Last name"
              v-decorator="['last_name']"
            />
            </a-form-item>
          </div>

          <div class="col-md-4" v-if="!user.user.school.auto_staff_id">
            <a-form-item label="Staff Code">
            <a-input
              placeholder="Staff Code"
              v-decorator="['staff_id', {rules: [{ required: true, message: 'Please input staff id!' }]}]"
            />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="system Id(Biometrics)">
            <a-input
              placeholder="System Id"
              v-decorator="['system_staff_id', {rules: [{ required: false, message: 'Please input system id!' }],initialValue: ''}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Job Title">
            <a-input
              placeholder="Assistant Professor"
              v-decorator="['title', {rules: [{ required: false, message: 'Please input a title!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item
              label="Gender"
            >
              <a-radio-group
                v-decorator="[
                  'gender',
                  {rules: [{ required: false, message: 'Please select a gender!' }],
                  initialValue: 'M'},
                ]"
              >
                <a-radio v-for="genderType in genderTypes" :value="genderType.value" :key="genderType.value" class="mr-2">
                  <span class="text-bold">{{genderType.name}}</span>
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item
              label="Category"
            >
              <a-radio-group
                v-decorator="[
                  'category',
                  {rules: [{ required: false, message: 'Please select a category!' }],
                  initialValue: 'GEN'},
                ]"
              >
                <a-radio v-for="categoryType in categoryTypes" :value="categoryType.value" :key="categoryType.value" class="mr-2">
                  <span class="text-bold">{{categoryType.name}}</span>
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item
              label="Date of birth"
            >
            <a-date-picker  @change="dateChangedListner"
              v-decorator="[
              'dob',
              {rules: [{ required: true, message: 'Please input date of birth' }], initialValue: moment()},
              ]"
              :format=dateFormat />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <!-- <staff-type-box></staff-type-box> -->
             <a-form-item label="Staff type" v-if="staffType">
                  <a-select
                  v-decorator="['staff_type_id',
                  {
                  initialValue: selectedValue,
                  rules: [{ required: true, message: 'Please select a staff type!!' }]
                  }
                  ]"
                  placeholder="Select type"
                  >
                <a-select-option v-for="stype in staffType" :key="stype.id" :value="stype.id">
                  {{ stype.name }}
                </a-select-option>
                </a-select>
              </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item
              label="Staff grade"
            >
              <a-select
                v-decorator="[
                  'staff_grade_id',
                  {rules: [{ required: true, message: 'Please select a staff grade!!' }]}
                ]"
                placeholder="Select grade"
              >
                <a-select-option v-for="staffGrade in staffGrades" :value="staffGrade.id" :key="staffGrade.id">
                 {{staffGrade.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item
              label="Appointment type"
            >
              <a-select
                v-decorator="[
                  'appointment_type',
                  {rules: [{ required: false, message: 'Please select an institute type!!' }],
                  initialValue: 'regular'}
                ]"
                placeholder="Select appointment type"
              >
                <a-select-option v-for="appointmentType in appointmentTypes" :value="appointmentType.value" :key="appointmentType.value">
                 {{appointmentType.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Teaching Subject">
            <a-input
              placeholder="Subject"
              v-decorator="['teacher_subject',]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Father's Full Name">
            <a-input
              placeholder="Full Name"
              v-decorator="['father_full_name',]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Husband's Name">
            <a-input
              placeholder="Husband's Name"
              v-decorator="['husband_name']"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Blood Group">
              <a-select
                v-decorator="[
                  'blood_group',
                  { rules: [{ required: false, message: 'Please select a blood group' }] }
                ]"
                placeholder="Select a blood group"
                :allowClear="true"
              >
                <a-select-option v-for="bg in bloodGroups" :value="bg.value" :key="bg.value">
                  {{ bg.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Aadhaar No.">
            <a-input
              placeholder="Aadhaar No."
              v-decorator="['aadhaar_no', {rules: [{ required: false, message: 'Please input valid 12-digit aadhaar number!', pattern: new RegExp(`^[0-9]{12}$`) }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Identification Mark">
            <a-input
              placeholder="e.g. Mole on neck"
              v-decorator="['id_mark']"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Date of Joining">
              <a-date-picker
                v-decorator="['joined_on']"
                :format="dateFormat"
                placeholder="Date of joining"
                style="width: 100%"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="ID Card Date of Issue">
              <a-date-picker
                v-decorator="['date_of_issue']"
                :format="dateFormat"
                placeholder="Date of issue"
                style="width: 100%"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="ID Card Valid Upto">
              <a-date-picker
                v-decorator="['valid_upto']"
                :format="dateFormat"
                placeholder="Valid upto"
                style="width: 100%"
              />
            </a-form-item>
          </div>
        </div>
        <a-divider />
        <p class="pt-3">Teaching Subjects</p>
        <div class="row mb-4">
          <div class="col-md-3 mb-2">
            <a-form-item label="For Session">
              <a-spin :spinning="sessionSpinning">
                <a-select
                  v-decorator="['session_id',{rules: [{ required: true, message: 'Please select a session!' },],initialValue: currentSession ? currentSession.id : '',},]"
                  placeholder="Select Session"
                  @change="handleSessionChange"
                >
                  <a-select-option
                    v-for="schoolSession in schoolSessions"
                    :value="schoolSession.id"
                    :key="schoolSession.id"
                  >
                    {{ schoolSession.name }}
                    <small class="text-primary ml-2">{{
                        currentSession.id === schoolSession.id ? "Current" : ""
                      }}</small>
                  </a-select-option>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>
        </div>
        <div class="row mb-4">
          <div
            class="col-12"
            v-for="(key, index) in subjectGroupings"
            :key="key"
          >
            <div class="d-flex">
              <div class="mr-2 pt-2">
                <span class="font-weight-bold">{{ index + 1 }}.</span>
              </div>
              <div class="col">
                <a-form-item>
                  <a-spin :spinning="classSpinning">
                    <a-select
                      style="width: 100%"
                      v-decorator="[`school_class_ids[${key}]`,{ rules: [{required: true,message: 'Please select a Subject Group!',},],},]"
                      placeholder="Select class"
                      @change="handleClassChange($event, key)"
                    >
                      <a-select-option
                        v-for="schoolClass in schoolClasses"
                        :value="schoolClass.id"
                        :key="schoolClass.id"
                      >
                        {{ schoolClass.name }}
                      </a-select-option>
                    </a-select>
                  </a-spin>
                </a-form-item>
              </div>
              <div class="col-md-3">
                <a-form-item>
                  <a-spin :spinning="sectionSpinning">
                  <a-select
                    v-decorator="[`section_ids[${key}]`,{rules: [{ required: true, message: 'Please select sections' },],initialValue: [],},]"
                    placeholer="Select sections"
                    mode="multiple"
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="section in sections[key]"
                      :value="section.id"
                      :key="section.id"
                    >
                      {{ section.name }}
                    </a-select-option>
                  </a-select>
                  </a-spin>
                </a-form-item>
              </div>
              <div class="col">
                <a-form-item>
                  <a-spin :spinning="subGroupSpinning">
                    <a-select
                      style="width: 100%"
                      v-decorator="[`subject_ids[${key}]`,{ rules: [{required: true,message: 'Please select a Subject!',},],initialValue: undefined},]"
                      placeholder="Select a subject"
                    >
                      <a-select-option
                        v-for="subject in subjects"
                        :value="subject.id"
                        :key="subject.id"
                      >
                        {{ subject.name }}
                      </a-select-option>
                    </a-select>
                  </a-spin>
                </a-form-item>
              </div>
              <div class="ml-2 pt-1">
                <button
                  class="btn btn-sm btn-danger"
                  @click.prevent="handleRemoveSubjectGrouping(key)"
                >
                  <i class="btn-addon-icon fe fe-trash-2" />
                </button>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="border-top border-bottom">
              <button
                class="btn btn-primary btn-with-export"
                @click.prevent="handleAddSubjectGrouping"
              >
                + Add subject
              </button>
            </div>
          </div>
        </div>
        <a-divider />
        <p class="pt-3">Add Shifts</p>
        <div class="row mb-4">
          <div
            class="col-12"
            v-for="(key, index) in shiftGroupings"
            :key="key"
          >
            <div class="d-flex">
              <div class="mr-2 pt-2">
                <span class="font-weight-bold">{{ index + 1 }}.</span>
              </div>
              <div class="col-md-6">
                <a-form-item>
                  <a-spin :spinning="shiftSpinning">
                    <a-select
                      style="width: 100%"
                      v-decorator="[`shift_ids[${key}]`,{ rules: [{required: true,message: 'Please select a Shift!',},],},]"
                      placeholder="Select a shift"
                    >
                      <a-select-option
                        v-for="shift in shifts"
                        :value="shift.id"
                        :key="shift.id"
                      >
                        {{ formatShiftLabel(shift) }}
                      </a-select-option>
                    </a-select>
                  </a-spin>
                </a-form-item>
              </div>
              <div class="col-md-5">
                <a-form-item>
                  <a-select
                    v-decorator="[`days[${key}]`,{rules: [{ required: false, message: 'Please select days' },],initialValue: [],},]"
                    placeholer="Select days"
                    mode="multiple"
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="day in days"
                      :value="day.value"
                      :key="day.value"
                    >
                      {{ day.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="ml-2 pt-1">
                <button
                  class="btn btn-sm btn-danger"
                  @click.prevent="handleRemoveShiftGrouping(key)"
                >
                  <i class="btn-addon-icon fe fe-trash-2" />
                </button>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="border-top border-bottom">
              <button
                class="btn btn-primary btn-with-export"
                @click.prevent="handleAddShiftGrouping"
              >
                + Add shift
              </button>
            </div>
          </div>
        </div>
        <a-divider />
        <p class="pt-3">Contact Details</p>
        <div class="row pb-3">
          <div class="col-md-9">
            <a-form-item label="Address">
            <a-input
              placeholder="Street address"
              v-decorator="['contact[address]', {rules: [{ required: false, message: 'Please input staff address!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="City">
            <a-input
              placeholder="City"
              v-decorator="['contact[city]', {rules: [{ required: false, message: 'Please input city!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="District">
            <a-input
              placeholder="District"
              v-decorator="['contact[district]', {rules: [{ required: false, message: 'Please input a district!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Landmark">
            <a-input
              placeholder="Landmark"
              v-decorator="['contact[landmark]', {rules: [{ required: false, message: 'Please input a landmark!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Pincode">
            <a-input
              placeholder="Pincode"
              v-decorator="['contact[pincode]', {rules: [{ required: false, message: 'Please input a pincode!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="State">
            <a-input
              placeholder="State"
              v-decorator="['contact[state]', {rules: [{ required: false, message: 'Please input a state!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Country">
            <a-input
              placeholder="Country"
              v-decorator="['contact[country]', {rules: [{ required: false, message: 'Please input a country!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item
              label="Email"
              extra="Email is required only if you don't provide a phone"
            >
              <a-input ref="remail"
                placeholder="Email"
                v-decorator="[
                  'contact[email]',
                  {
                    rules: [{
                      type: 'email', message: 'The input is not valid email!',
                    }, {
                      required: !form.getFieldValue('contact[phone]') || form.getFieldValue('contact[email]'), message: 'Please input an email!',
                    }]
                  }
                ]"
                @change="handleEmailChange"
                @focusout="clearError('contact[email]')"
              />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Phone">
              <a-input
                placeholder="Phone"
                v-decorator="['contact[phone]', {rules: [{ required: !form.getFieldValue('contact[email]'), message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
                width="100%"
                @change="handlePhoneChange"
                @focusout="clearError('contact[phone]')"
              >
              <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'contact[country_code]',
                    { initialValue: '91' }
                  ]"
                  style="width: 70px"
                >
                  <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                    <span class="text-bold">{{countryCode.name}}</span>
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Alt. Phone">
              <a-input
                placeholder="Alt. Phone"
                v-decorator="['contact[alt_phone]', {rules: [{ required: false, message: 'Please input an valid alt phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
                width="100%"
              >
                <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'contact[alt_country_code]',
                    { initialValue: '91' }
                  ]"
                  style="width: 70px"
                >
                  <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                    <span class="text-bold">{{countryCode.name}}</span>
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </div>
        </div>

        <a-divider />
        <p class="pt-3">Highest Educational Qualification</p>
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item label="Qualification">
            <a-input
              placeholder="Qualification"
              v-decorator="['highest_q', {rules: [{ required: true, message: 'Please input a qualification!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Graduation year">
            <a-input
              placeholder="Graduation year"
              v-decorator="['highest_q_year', {rules: [{ required: false, message: 'Please input graduation year!', pattern: new RegExp(`^[0-9]{4}$`) }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Score or %">
            <a-input-number
              style="width:100%;"
              :min="0" :max="1000"
              placeholder="Score or %"
              v-decorator="['pc_score', {rules: [{ required: false, message: 'Please input a score!' }]}]"
            />
            </a-form-item>
          </div>
        </div>

        <a-divider />
        <p class="pt-3">Highest Professional Qualification (eg. TET)</p>
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item label="Qualification">
            <a-input
              placeholder="Qualification"
              v-decorator="['pro_q', {rules: [{ required: false, message: 'Please input a qualification!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Graduation year">
            <a-input
              placeholder="Graduation year"
              v-decorator="['pro_q_year', {rules: [{ required: false, message: 'Please input graduation year!', pattern: new RegExp(`^[0-9]{4}$`) }]}]"
            />
            </a-form-item>
          </div>
        </div>

        <a-divider />
        <p class="pt-3">Teacher Training Details</p>
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item label="BRC (in days)">
            <a-input-number
              style="width:100%;"
              :min="0" :max="1000"
              placeholder="BRC (in days)"
              v-decorator="['brc', {rules: [{ required: false, message: 'Please input brc details!' }]}]"
            />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="CRC (in days)">
            <a-input-number
              style="width:100%;"
              :min="0" :max="1000"
              placeholder="CRC (in days)"
              v-decorator="['crc', {rules: [{ required: false, message: 'Please input crc details!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="DIET (in days)">
            <a-input-number
              style="width:100%;"
              :min="0" :max="1000"
              placeholder="DIET (in days)"
              v-decorator="['diet', {rules: [{ required: false, message: 'Please input DIET details!' }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item
              label="Trained to use computer"
            >
              <a-radio-group
                  v-decorator="[
                    'computer_training',
                    {rules: [{ required: true, message: 'This value is required' }],  initialValue: 1 },
                  ]"
                >
                  <a-radio :value="1">Yes</a-radio>
                  <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item
              label="Trained for teaching CWSN"
            >
              <a-radio-group
                v-decorator="[
                  'cwsn_training',
                  {rules: [{ required: true, message: 'This value is required' }],  initialValue: 1 },
                ]"
              >
                 <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

        </div>

        <a-divider />
        <p class="pt-3">Other Details</p>
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item
              label="Is disabled?"
            >
              <a-radio-group
                  @change="handleDisabilityChange"
                  v-decorator="[
                    'is_disabled',
                    {rules: [{ required: true, message: 'This value is required' }],  initialValue: 0 },
                  ]"
                >
                  <a-radio :value="1">Yes</a-radio>
                  <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="Details if so">
            <a-input
              placeholder="Details of disablity"
              v-decorator="['disabled_details', {rules: [{ required: false, message: 'Please add details of disability!' }]},]"
              :disabled="!form.getFieldValue('is_disabled')"
            />
            </a-form-item>
          </div>

        </div>

        <a-divider />
        <p class="pt-3">User Details</p>
        <div class="row">
          <div class="col-md-6 col-12 mb-3">
            <a-form-item
              label="Photo"
            >
              <div class="d-flex align-items-start">
                <div v-if="photoPreview" class="mr-3">
                  <div class="p-1 border rounded bg-light">
                    <img :src="photoPreview" alt="photo preview" style="max-height: 100px; max-width: 100px; object-fit: cover;" />
                  </div>
                </div>
                <div>
                  <a-upload
                    v-decorator="['photo']"
                    :multiple="false"
                    :fileList="photoFileList"
                    @change="handlePhotoChange"
                    :beforeUpload="beforePhotoUpload"
                    :disabled="uploadDisabled"
                  >
                    <a-button v-if="photoFileList.length === 0">
                      <a-icon type="upload" /> Select File
                    </a-button>
                  </a-upload>
                  <a-button v-if="photoFileList.length > 0" type="link" class="text-danger p-0 mt-1" @click="handleCancelPhoto">
                    <a-icon type="close-circle" /> Cancel Selected Photo
                  </a-button>
                </div>
              </div>
            </a-form-item>
            <p class="font-italic text-warning">Should be JPG/PNG and less than 2MB </p>
          </div>
          <div class="col-md-6 col-12">
            <a-form-item
              label="Signature"
            >
              <a-upload
                v-decorator="['signature']"
                :multiple="false"
                :fileList="signatureFileList"
                @change="handleSignatureChange"
                :beforeUpload="beforeSignatureUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="signatureFileList.length === 0">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
            <p class="font-italic text-warning">Should be JPG/PNG and less than 2MB </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12 mb-3">
            <a-form-item label="Password">
              <a-input ref="rpassword"
                       v-decorator="[
                  'password',
                  {
                    rules: [{
                      required: true, message: 'Please input a password!',
                    }, {
                      validator: validateToNextPassword,
                    }],
                  }
                ]"
                       type="password"
              />
            </a-form-item>
          </div>

          <div class="col-md-6 col-12">
            <a-form-item label="Confirm Password">
              <a-input
                v-decorator="[
                  'confirm_password',
                  {
                    rules: [{
                      required: true, message: 'Please confirm user password!',
                    }, {
                      validator: compareToFirstPassword,
                    }],
                  }
                ]"
                type="password"
                @blur="handleConfirmBlur"
              />
            </a-form-item>
          </div>
        </div>
        <!-- Roles -->
        <a-divider />
        <p class="pt-3">User Roles</p>
        <role-comp :data="rolesFromServer" @onSelect="handleRoleSelect"></role-comp>
        <!-- End Roles -->

        <a-divider />
        <div class="row justify-content-between py-3">
          <div class="col-md-4">
            <a-button key="clear" class="btn btn-light" @click="handleClear">Clear Form</a-button>
          </div>
          <div class="col-md-4 text-md-right">
            <a-button key="back" @click="handleCancel" class="mr-3">Cancel</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add Staff</a-button>
          </div>
        </div>
      </a-form>
    </a-drawer>
  </div>
</template>

<style scoped>
.ant-drawer-close-x{
  margin-right: 0.7rem;
}
</style>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { appointmentTypes, genderTypes, categoryTypes } from '../data'
import { countryCodes, nameSuffixes, bloodGroups } from '@/services/globaldata'
// import staffTypeBox from '@/components/staff/Other/staffTypeBox'
import roleComp from '@/components/staff/Role/index'
import { find } from 'lodash'
import { compressImage } from '@/utils/imageCompressor'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (value === null || value === undefined) {
      return undefined // or whatever default value you want for null
    }
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    if (typeof value === 'object' && value._isAMomentObject === true) {
      return moment(value).format('YYYY-MM-DD')
    }
    return value
  },
}

export default {
  name: 'AddStaff',
  components: { roleComp },
  mounted: function() {
    this.getSessions()
    this.getSubjects()
    this.getShifts()
    this.getStaffType()

    // this.form = this.$form.createForm(this)
    this.$http.get('/api/staff_grade')
      .then(({ data }) => {
        this.staffGrades = data.data
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/school-role')
      .then(({ data }) => {
        this.rolesFromServer = data.data
        // console.log('rolesFromServer ', data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  beforeCreate() {
    // this.form = this.$form.createForm(this)
    // this.form.getFieldDecorator('last_name', { initialValue: [], preserve: true })
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      confirmDirty: false,
      loading: false,
      uploadDisabled: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
      photoFileList: [],
      photoPreview: null,
      signatureFileList: [],
      appointmentTypes,
      genderTypes,
      categoryTypes,
      countryCodes,
      nameSuffixes,
      bloodGroups,
      roles: [],
      rolesFromServer: [],
      userpassword: '',
      schoolSessions: [],
      schoolClasses: [],
      sections: [],
      staffType: [],
      stafftypeSpinning: false,
      sessionSpinning: false,
      classSpinning: false,
      sectionSpinning: false,
      subjectGroupings: [],
      groupingCounter: 0,
      subjectGroups: [],
      subGroupSpinning: false,
      shifts: [],
      shiftSpinning: false,
      shiftGroupings: [],
      shiftGroupingCounter: 0,
      days: [
        { name: 'Monday', value: 'MON' },
        { name: 'Tuesday', value: 'TUE' },
        { name: 'Wednesday', value: 'WED' },
        { name: 'Thursday', value: 'THU' },
        { name: 'Friday', value: 'FRI' },
        { name: 'Saturday', value: 'SAT' },
        { name: 'Sunday', value: 'SUN' },
      ],
      selectedValue: null,
    }
  },

  computed: {
    currentSession: function () {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    dateChangedListner(date, dateString) {
      var mdate = new Date(date)
      this.userpassword = `${mdate.getDate().toString().padStart(2, '0')}${(mdate.getMonth() + 1).toString().padStart(2, '0')}${mdate.getFullYear()}`

      this.form.setFieldsValue({
        password: this.userpassword,
        confirm_password: this.userpassword,
      })
    },
    formatShiftLabel(shift) {
      // Check if both start and end times exist
      if (shift.start_time && shift.end_time) {
        const startTimeAmPm = moment(shift.start_time, 'HH:mm').format('h:mm A')
        const endTimeAmPm = moment(shift.end_time, 'HH:mm').format('h:mm A')
        if (shift.break_start && shift.break_end) {
          const breakStartAmPm = moment(shift.break_start, 'HH:mm').format('h:mm A')
          const breakEndAmPm = moment(shift.break_end, 'HH:mm').format('h:mm A')
          return `${shift.name} (${startTimeAmPm} - ${breakStartAmPm} - ${breakEndAmPm} - ${endTimeAmPm})`
        } else {
          return `${shift.name} (${startTimeAmPm} - ${endTimeAmPm})`
        }
      } else {
        return shift.name
      }
    },
    handleRoleSelect(v) {
      this.roles = v
      // console.log(`this.roles = ${this.roles}`)
    },
    showModal() {
      this.visible = true
    },
    handleEmailChange (e) {
      if (e.target.value) {
        if (!this.form.getFieldValue('contact[phone]')) {
          this.form.setFields({ 'contact[phone]': { errors: undefined } })
        }
      }
    },
    handlePhoneChange (e) {
      if (e.target.value) {
        if (!this.form.getFieldValue('contact[email]')) {
          this.form.setFields({ 'contact[email]': { errors: undefined } })
        }
      }
    },
    clearError(field) {
      if (!this.form.getFieldValue(`${field}`)) {
        this.form.setFields({ [field]: { errors: undefined } })
      }
    },
    handleDisabilityChange(e) {
      if (!e.target.value) {
        this.form.setFieldsValue({ disabled_details: '' })
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      // this.uploadDisabled = false
    },
    beforePhotoUpload(file) {
      return this.validateUpload(file, 'photoFileList')
    },
    beforeSignatureUpload(file) {
      return this.validateUpload(file, 'signatureFileList')
    },
    validateUpload(file, listName) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isPNG)) {
        this.$message.error('You can upload only JPG or PNG file!')
        return Promise.reject(new Error('Invalid format'))
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must be smaller than 2MB!')
        return Promise.reject(new Error('File too large'))
      }
      if (listName === 'photoFileList') {
        file.compressedPromise = compressImage(file)
        const reader = new FileReader()
        reader.onload = (e) => {
          this.photoPreview = e.target.result
        }
        reader.readAsDataURL(file)
      }
      this[listName] = [file]
      return false
    },
    handleCancelPhoto() {
      this.photoFileList = []
      this.photoPreview = null
      this.form.setFieldsValue({ photo: undefined })
    },
    handlePhotoChange({ fileList }) {
      this.photoFileList = fileList
    },
    handleSignatureChange({ fileList }) {
      this.signatureFileList = fileList
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    handleAddShiftGrouping() {
      this.shiftGroupingCounter++
      if (this.shiftGroupings.length < 10) {
        this.shiftGroupings.push(this.shiftGroupingCounter)
      }
    },
    handleRemoveShiftGrouping(key) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Click Ok to remove this shift.`,
        onOk: () => {
          this.shiftGroupings = this.shiftGroupings.filter(
            (item) => item !== key
          )
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
    getStaffType: function () {
      this.stafftypeSpinning = true
      this.$http.get('/api/staff_type')
        .then(({ data }) => {
          this.staffType = data.data
          this.stafftypeSpinning = false
        })
        .catch(error => {
          console.error('error at staff type component.', error)
        // console.log(error)
        })
    },
    getShifts: function () {
      this.shiftSpinning = true
      this.$http
        .get('/api/attendance-shift/all')
        .then(({ data }) => {
          this.shifts = data.data
          this.shiftSpinning = false
        })
        .catch((error) => {
          console.log(error)
          this.shiftSpinning = false
        })
    },
    handleAddSubjectGrouping() {
      this.groupingCounter++
      if (this.subjectGroupings.length < 10) {
        this.subjectGroupings.push(this.groupingCounter)
      }
    },
    handleRemoveSubjectGrouping(key) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Click Ok to remove this subject grouping.`,
        onOk: () => {
          this.subjectGroupings = this.subjectGroupings.filter(
            (item) => item !== key
          )
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
    getSessions: function () {
      this.sessionSpinning = true
      this.$http
        .get('/api/session')
        .then(({ data }) => {
          this.schoolSessions = data.data
          this.selectedSession = find(data.data, ['is_current', 1]).id
          this.getClasses()
          this.sessionSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSubjects: function () {
      this.$http
        .get('/api/subject')
        .then(({ data }) => {
          this.subjects = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getClasses: function () {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          // this.getSubjectGroups()
          this.classSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleSessionChange(value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.getClasses()
    },
    handleClassChange (value, rowKey) {
      this.selectedSection = undefined
      this.data = null
      if (value) {
        this.selectedClass = value
        this.sectionSpinning = true
        this.getClassSections(value, rowKey)
      }
    },
    getClassSections(value, rowKey) {
      this.$http.get(`/api/section/class/${value}`)
        .then(({ data }) => {
          this.sections[rowKey] = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSubmit(e) {
      this.loading = true

      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          // console.log(values.logo)
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to add the new staff!`,
            onOk: async () => {
              if (!values.alt_phone) {
                values.alt_country_code = undefined
              }

              values.confirm_password = undefined

              let photoFile = null
              if (values.photo) {
                if (values.photo.fileList && values.photo.fileList.length !== 0) {
                  photoFile = values.photo.file
                }
              }
              delete values.photo

              if (photoFile) {
                if (photoFile.compressedPromise) {
                  photoFile = await photoFile.compressedPromise
                } else {
                  photoFile = await compressImage(photoFile)
                }
              }

              let signatureFile = null
              if (values.signature) {
                signatureFile = values.signature.file
                values.signature = undefined
              }

              let formData = window.jsonToFormData(values, options)

              if (photoFile) {
                formData.append('photo', photoFile)
              }
              if (signatureFile) {
                formData.append('signature', signatureFile)
              }

              // -- Role being suppressed for a while
              // console.log(`lenght of roles is ${this.roles.length}`)
              // console.log(`stringified : ${JSON.stringify(this.roles)}`)
              if (this.roles.length < 1) {
                formData.append('school_role', null)
              } else {
                formData.append('school_role', JSON.stringify(this.roles))
              }

              this.$http
                .post('/api/teacher', formData) // .post('/api/teacher', formData)
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully added',
                    description: `${data.data.first_name} ${data.data.last_name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.loading = false
    },
    handleClear(e) {
      this.form.resetFields()
    },
  },
}
</script>
